module.exports = __webpack_public_path__ + "static/media/ankh.6e7f8950.svg";